module.exports = __webpack_public_path__ + "files/ef2309096b6f502bbad857b973fd1f89.png";